import { render, staticRenderFns } from "./MerchantReportDetail.vue?vue&type=template&id=500cc58e"
import script from "./MerchantReportDetail.vue?vue&type=script&lang=js"
export * from "./MerchantReportDetail.vue?vue&type=script&lang=js"
import style0 from "./MerchantReportDetail.vue?vue&type=style&index=0&id=500cc58e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports